module.exports = __webpack_public_path__ + "img/Part1.04373ad.png";